import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, MessageSquare } from "lucide-react";
import { api } from "@/lib/api";

const MobileStickyCTA = () => {
  const [phone, setPhone] = useState("(813) 555-0100");

  useEffect(() => {
    api.get("/config").then(({ data }) => setPhone(data.business_phone)).catch(() => {});
  }, []);

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-border bg-background/95 backdrop-blur shadow-[0_-2px_12px_rgba(0,0,0,0.08)] md:hidden"
      data-testid="mobile-sticky-cta"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <a
        href={`tel:${phone.replace(/[^0-9+]/g, "")}`}
        className="flex items-center justify-center gap-2 border-r border-border py-3.5 text-sm font-bold uppercase tracking-wider text-secondary hover:bg-muted"
        data-testid="mobile-sticky-call"
      >
        <Phone className="h-4 w-4" /> Call Now
      </a>
      <Link
        to="/contact"
        className="flex items-center justify-center gap-2 bg-primary py-3.5 text-sm font-bold uppercase tracking-wider text-primary-foreground hover:bg-[hsl(16,55%,42%)]"
        data-testid="mobile-sticky-quote"
      >
        <MessageSquare className="h-4 w-4" /> Get Quote
      </Link>
    </div>
  );
};

export default MobileStickyCTA;
